module.exports = __webpack_public_path__ + "edf30153753e16cfcd3edb22aa43dc57.png";